/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S3_P2Inputs */

const en_guide_json_vs_yaml_xml_s3_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`However, YAML's whitespace sensitivity can cause subtle bugs: a wrong indent can completely change the meaning of your data. This makes YAML more error-prone than JSON for machine-generated content.`)
};

const ko_guide_json_vs_yaml_xml_s3_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하지만 YAML의 공백 민감성은 미묘한 버그를 일으킬 수 있습니다: 잘못된 들여쓰기가 데이터의 의미를 완전히 바꿀 수 있습니다. 이로 인해 기계 생성 콘텐츠에서는 YAML이 JSON보다 오류가 발생하기 쉽습니다.`)
};

const ja_guide_json_vs_yaml_xml_s3_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ただし、YAMLの空白への依存性は微妙なバグを引き起こす可能性があります: インデントを間違えるとデータの意味が完全に変わることがあります。そのため、YAMLは機械生成コンテンツにおいてJSONよりもエラーが起きやすくなります。`)
};

/**
* | output |
* | --- |
* | "However, YAML's whitespace sensitivity can cause subtle bugs: a wrong indent can completely change the meaning of your data. This makes YAML more error-prone..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S3_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s3_p2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S3_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S3_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s3_p2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s3_p2(inputs)
	return ja_guide_json_vs_yaml_xml_s3_p2(inputs)
});